import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

/** Parse yes/no query values into boolean. */
const parseQuery = route => {
  const { query } = route;

  if (!query) {
    return {};
  }

  return Object.entries(query).reduce((acc, [key, value]) => {
    if (value.toLowerCase() === 'true' || value.toLowerCase() === 'yes') {
      acc[key] = true;

      return acc;
    }

    if (value.toLowerCase() === 'false' || value.toLowerCase() === 'no') {
      acc[key] = false;

      return acc;
    }

    acc[key] = value;

    return acc;
  }, {});
};

const routes = [
  {
    path: '/validation',
    name: 'ValidationPage',
    component: () => import('@/views/ValidationPage.vue'),
    props: route => parseQuery(route)
  },
  {
    path: '/error',
    name: 'CriticalErrorPage',
    component: () => import('@/views/CriticalErrorPage.vue'),
    props: true
  },
  {
    path: '/main/:doctorSlug/:hashedDataId',
    name: 'MainPage',
    component: () => import('@/views/MainPage.vue'),
    props: true
  },
  {
    path: '/checkout/:doctorSlug/:hashedDataId',
    name: 'CheckoutPage',
    component: () => import('@/views/CheckoutPage.vue'),
    props: true
  },
  {
    path: '/renew/:doctorSlug/:hashedPrototypeTreatmentId',
    name: 'IntermediateRenewPage',
    component: () => import('@/views/IntermediateRenewPage.vue'),
    props: route => ({ ...route.params, isPaidOfferLinkUsed: !!route.query.isPaidOfferLinkUsed })
  },
  {
    path: '/product-details/:doctorSlug/:hashedDataId/:productName',
    name: 'ProductDetailsPage',
    component: () => import('@/views/product-details/ProductDetailsPage.vue'),
    props: true
  },
  {
    path: '/:doctorSlug/:hashedDataId',
    name: 'WelcomePage',
    component: () => import('@/views/WelcomePage.vue'),
    props: true
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      const scrollToSavedPosition = () => {
        window.scrollTo(0, savedPosition.y);
        window.removeEventListener('page-loaded', scrollToSavedPosition);
      };

      window.addEventListener('page-loaded', scrollToSavedPosition);

      return savedPosition;
    }

    if (to.hash) {
      const offset = { x: 0, y: 60 };

      const scrollToHash = () => {
        window.removeEventListener('page-loaded', scrollToHash);

        const sectionId = to.hash.replace('#', '');
        const section = document.getElementById(sectionId);

        if (section) {
          const { y } = section.getBoundingClientRect();

          window.scrollTo(0, y - offset.y);
        }
      };

      window.addEventListener('page-loaded', scrollToHash);

      return {
        selector: to.hash,
        behavior: 'smooth',
        offset
      };
    }

    if (to.path !== from.path) {
      return { x: 0, y: 0 };
    }

    return {};
  }
});

export default router;
